import React from "react";
import errorImg from "../../images/signinImg1.svg";
import { Box, Typography } from "@mui/material";

const PermissionDenied = () => {
  return (
    <Box sx={{display: 'flex', width: '100%'}}>
      <Box sx={{
        display: 'flex',
        width: '100%',
        height: '100vh',
        alignItems: 'center',
        paddingLeft: '5%',
      }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          width: '40%',
          lineHeight: '60px',
          height: '100vh',
          zIndex: 5
        }}>
          <Typography
            variant='h1'
            sx={{
              fontSize: '120px',
              fontWeight: 400,
            }}
          >
            Rota restrita!
          </Typography>

          <Typography
            variant='p'
            sx={{
              fontSize: '44px',
              marginTop: 5
            }}
            >
            Você não tem permissão para acessar essa rota.
          </Typography>
          <Typography
            variant='p'
            sx={{
              fontSize: '44px',
              marginTop: 5
            }}
          >
            Entre em contato com o administrador do sistema para obter permissão. 
          </Typography>
        </Box>
        <Box
          component="img"
          sx={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            maxHeight: '80%',
          }}
          alt="Error"
          src={errorImg}
        />
      </Box>
    </Box>
  );
}

export default PermissionDenied;
